var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_vm._t("default")],2),_c('div',{staticClass:"d-flex",staticStyle:{"float":"right","right":"0px","height":"0","top":"30px","position":"absolute"}},[_c('app-bar-i18n'),_c('app-bar-theme-switcher',{staticClass:"mx-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }